module.exports = "<app-navbar *ngIf=\"disableMenu\"></app-navbar>\n\n<div class=\"container-fluid\">\n  <router-outlet></router-outlet>\n</div>\n"